module.exports = __webpack_public_path__ + "img/base_restauration_miel.1c996ae9.svg";